import { Injectable } from '@angular/core';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap'; // If you're using NgbToast directly

@Injectable({
  providedIn: 'root'
})
export class AppToastService {
  toasts: Toast[] = [];

  show(header: string, body: string, delay: number = 5000, classname = "") {
    this.toasts.push({ header, body, delay, classname });
  }

  remove(toast: Toast) {
    this.toasts = this.toasts.filter(t => t != toast);
  }
}

export interface Toast {
  header: string;
  body: string;
  delay: number;
  classname: string;
}
